// Contact form → Lambda Function URL (JSON POST). Shows inline status,
// disables the button while sending, and re-enables on error. The honeypot
// field (`company`) is submitted as-is; the server silently drops it if filled.
export default function initContact() {
  const form = document.querySelector("[data-contact-form]")
  if (!form) return

  const endpoint = form.getAttribute("data-endpoint")
  const button = form.querySelector("[data-contact-submit]")
  const status = form.querySelector("[data-contact-status]")
  const originalLabel = button ? button.textContent : "Verstuur bericht"

  const setStatus = (msg, ok) => {
    if (!status) return
    status.textContent = msg
    status.classList.remove("hidden", "text-emerald-600", "text-red-600")
    status.classList.add(ok ? "text-emerald-600" : "text-red-600")
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault()
    if (!endpoint) return

    const data = {
      name: form.name.value,
      email: form.email.value,
      message: form.message.value,
      company: form.company ? form.company.value : "",
    }

    button.disabled = true
    button.textContent = "Versturen…"

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(data),
      })
      if (res.ok) {
        form.reset()
        button.textContent = "Verzonden ✓"
        button.classList.remove("bg-flame-500", "hover:bg-flame-600")
        button.classList.add("bg-emerald-500")
        setStatus("Bedankt! Je bericht is verstuurd — we reageren snel.", true)
      } else {
        throw new Error("bad status " + res.status)
      }
    } catch (_) {
      button.disabled = false
      button.textContent = originalLabel
      setStatus("Er ging iets mis. Probeer het opnieuw of mail info@lekdetectie.online.", false)
    }
  })
}
